// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"ffb8bcd6","66":"1fca7490","213":"4726a5a3","453":"54292a4b","687":"f28bc71b","947":"3c30a925"}[chunkId] + ".chunk.js";
};